import { ComparisonOperator } from 'types/embedded/gatewayRule';

const COMPARISON_OPERATOR_COLORS: Record<string, string> = {
  equal_array: 'success.main',
  not_equal_array: 'error.main',
};

export function getComparisonOperatorColor(
  operator?: Partial<ComparisonOperator>,
): string | undefined {
  return COMPARISON_OPERATOR_COLORS[operator?.alias || operator?.id || ''];
}
